import { generateImagePath } from '../../../../helpers/helpers';
import AddMoreButton from '../inputs/AddMoreButton';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';

export default function PropertyOverViewSection({
  investmentData,
  handleInputChange,
  handleAddItem,
  dispatch,
  removeItemFromArray,
}) {
  // English Overview Section Fields
  const overviewSectionFieldsEn = {
    label: 'Overview Title',
    value: investmentData.en.overviewSection.title,
    section: 'overviewSection',
    field: 'title',
    config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
  };

  // English Overview Paragraphs
  const overviewSectionsParagraphsEn =
    investmentData.en.overviewSection.paragraphs.map((paragraph, index) => ({
      label: `Paragraph ${index + 1}`,
      value: paragraph,
      section: 'overviewSection',
      field: 'paragraphs',
      index,
      config: { ...commonFieldConfig['en'][commonFieldTypes.textarea] },
    }));

  // Arabic Overview Section Fields
  const overviewSectionFieldsAr = {
    label: 'عنوان النظرة العامة',
    value: investmentData.ar.overviewSection.title,
    section: 'overviewSection',
    field: 'title',
    config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
  };

  // Arabic Overview Paragraphs
  const overviewSectionsParagraphsAr =
    investmentData.ar.overviewSection.paragraphs.map((paragraph, index) => ({
      label: `الفقرة ${index + 1}`,
      value: paragraph,
      section: 'overviewSection',
      field: 'paragraphs',
      index,
      config: { ...commonFieldConfig['ar'][commonFieldTypes.textarea] },
    }));

  return (
    <section className="mb-5">
      <h3 className="mb-3">Property Overview</h3>
      <img
        src={generateImagePath('overview-section.webp')}
        alt=""
        className="mb-3 w-100"
      />

      <div className="row">
        <div className="col-md-6">
          <FieldTypeSelector
            label={overviewSectionFieldsEn.label}
            fieldName={overviewSectionFieldsEn.field}
            value={overviewSectionFieldsEn.value}
            config={overviewSectionFieldsEn.config}
            onInputChange={(e) =>
              handleInputChange({
                e,
                section: overviewSectionFieldsEn.section,
                field: overviewSectionFieldsEn.field,
                lang: 'en',
              })
            }
          />
        </div>

        <div className="col-md-6" dir="rtl">
          <FieldTypeSelector
            label={overviewSectionFieldsAr.label}
            fieldName={overviewSectionFieldsAr.field}
            value={overviewSectionFieldsAr.value}
            config={overviewSectionFieldsAr.config}
            onInputChange={(e) =>
              handleInputChange({
                e,
                section: overviewSectionFieldsAr.section,
                field: overviewSectionFieldsAr.field,
                lang: 'ar',
              })
            }
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <h4 className="mt-4 mb-3">Overview Paragraphs</h4>
          {overviewSectionsParagraphsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>

        <div className="col-md-6" dir="rtl">
          <h4 className="mt-4 mb-3">الفقرات العامة</h4>
          {overviewSectionsParagraphsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>
        <AddMoreButton
          handleAddItem={() => handleAddItem('overviewSection', 'paragraphs')}
        />
      </div>
    </section>
  );
}
